import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import ManageClinics from './ManageClinics.js';

export default WithGASetup(ManageClinics, AuthContext);
